export default __webpack_public_path__ + "media/images/linkedin-social-9b46fb6453545e64b7d7d68e83c65a5e.svg";